var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "cart",
      class: { "as-fullwidth": _vm.isPlan, "has-alert": _vm.hasAlert }
    },
    [
      _c(
        "section",
        { staticClass: "cart-config" },
        [
          _c(
            "div",
            { staticClass: "flex-column cart-config-back ovy-reset mb-7" },
            [
              _c(
                "a",
                {
                  staticClass: "block",
                  attrs: {
                    href: "/home",
                    title: _vm.$t.__("pages.account.CartTemplate.home_page")
                  }
                },
                [
                  _c("SaasIcon", {
                    staticClass: "m-0 mb-2 secondary-blue",
                    attrs: {
                      icon: "svgLogoSellsyText",
                      width: "118",
                      height: "28"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.canBack
                ? _c("CompassBackForwardButton", {
                    attrs: {
                      label: _vm.$t.__("common.actions.back"),
                      link: _vm.buildUrlClient,
                      back: ""
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm._t("configuration", [_vm._v("config")])
        ],
        2
      ),
      _vm._v(" "),
      !_vm.isPlan
        ? _c(
            "section",
            {
              staticClass: "cart-recap zi-2",
              class: _vm.advCheck ? "primary-05-bkg" : "gray-0-bkg"
            },
            [
              _vm.advCheck
                ? _c("adv-authorization")
                : _vm._t("resume", [_vm._v("resume")])
            ],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }